import { storyblokEditable, StoryblokComponent } from "@storyblok/react";

const Accordion = ({ blok }) => {
  const light = blok.light_mode;

  return (
    <section
      {...storyblokEditable(blok)}
      className={`px-6 py-12 flex justify-center transition-colors duration-300 ${
        light ? "bg-white text-black" : "bg-[#0C1B3A] text-white"
      }`}
    >
      <div className="w-full max-w-[960px]">
        {/* Main Title */}
        {blok.title && (
          <h2
            className={`text-3xl font-semibold mb-8 text-left transition-colors duration-300 ${
              light ? "text-black" : "text-white"
            }`}
          >
            {blok.title}
          </h2>
        )}

        {/* Accordion Items */}
        <div
          className={`divide-y transition-colors duration-300 ${
            light ? "divide-gray-200" : "divide-[#2A3A5B]"
          }`}
        >
          {blok.items?.map((nestedBlok) => (
            <StoryblokComponent
              blok={{ ...nestedBlok, light_mode: light }}
              key={nestedBlok._uid}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Accordion;
